import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parseMetadata = function parseMetadata(response) {
  var _ref, _headers$xAmznReque;

  var headers = response.headers,
      statusCode = response.statusCode;
  return _objectSpread(_objectSpread({}, isMetadataBearer(response) ? response.$metadata : {}), {}, {
    httpStatusCode: statusCode,
    requestId: (_ref = (_headers$xAmznReque = headers['x-amzn-requestid']) !== null && _headers$xAmznReque !== void 0 ? _headers$xAmznReque : headers['x-amzn-request-id']) !== null && _ref !== void 0 ? _ref : headers['x-amz-request-id'],
    extendedRequestId: headers['x-amz-id-2'],
    cfId: headers['x-amz-cf-id']
  });
};

var isMetadataBearer = function isMetadataBearer(response) {
  return typeof (response === null || response === void 0 ? void 0 : response.$metadata) === 'object';
};

export { parseMetadata };